import styled from "@emotion/styled";
import { FC } from "react";

import { Avatar, Tag } from "@livechat/design-system-react-components";

import { IAgent } from "store/entities/agents";

const MEMBERS_LIMIT = 5;

interface IMembersProps {
  agents: IAgent[];
}

export const TeamMembers: FC<IMembersProps> = ({ agents }) => (
  <MembersStyled>
    <ListStyled>
      {agents.slice(0, MEMBERS_LIMIT).map(agent => (
        <AvatarStack key={agent.id} title={agent.name}>
          <Avatar
            type={agent.avatar ? "image" : "text"}
            src={agent.avatar ? agent.avatar : undefined}
            text={agent.name ?? agent.email}
            size="xsmall"
          />
        </AvatarStack>
      ))}
    </ListStyled>
    {agents.length > MEMBERS_LIMIT && <Tag size="small">+{agents.length - MEMBERS_LIMIT} more</Tag>}
  </MembersStyled>
);

const MembersStyled = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const ListStyled = styled.div`
  position: relative;
  display: flex;
  margin-right: 19px;
  flex-direction: row;
`;

const AvatarStack = styled.div`
  position: relative;
  width: 20px;
`;
